import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=53af3d34&"
import script from "./CategoryFilters.vue?vue&type=script&lang=js&"
export * from "./CategoryFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports